<script setup lang="ts">
import { computed } from 'vue';
import type { IframeEntry } from './types';

const props = defineProps<{
  entry: IframeEntry;
  visible: boolean;
}>();

const urlParams = computed(() =>
  props.entry.kind === 'url' ? props.entry.params : null,
);
const srcdocParams = computed(() =>
  props.entry.kind === 'srcdoc' ? props.entry.params : null,
);

const itemStyle = computed(() => {
  const entry = props.entry;
  if (entry.placement === 'inline') {
    const rect = entry.rect;
    const shown = props.visible && rect != null;
    return {
      top: rect ? `${rect.top}px` : '0',
      left: rect ? `${rect.left}px` : '0',
      width: rect ? `${rect.width}px` : '0',
      height: rect ? `${rect.height}px` : '0',
      display: shown ? 'block' : 'none',
    };
  }
  return {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: props.visible ? 'block' : 'none',
  };
});
</script>

<template>
  <div class="itp-keepalive-item" :style="itemStyle">
    <iframe
      v-if="urlParams"
      class="itp-keepalive-item__frame"
      :src="urlParams.src"
      :sandbox="urlParams.sandbox"
    />

    <iframe
      v-else-if="srcdocParams"
      class="itp-keepalive-item__frame"
      :srcdoc="srcdocParams.html"
      :sandbox="srcdocParams.sandbox ?? 'allow-same-origin'"
    />
  </div>
</template>
